/// <amd-module name="TFS/Security/Common/DataSource/SecurityRootViewDataSource" />
import { PermissionsReportRequest, PermissionsReportResource } from "TFS/Admin/Common/Contracts/PermissionsReport";
import { getPermissionsReportClient } from "TFS/Admin/Common/RestClient/PermissionsReport";
import { IVssPageContext } from "VSS/Platform/Context";
import { IVssContributionService } from "VSS/Platform/Contribution";
import { ISecurityViewData } from "../Contracts";

const securityViewDataProviderId = "ms.vss-admin-web.security-view-data-provider";

export function getSecurityViewData(
    pageContext: IVssPageContext,
    permissionSetId: string,
    permissionSetToken: string
): Promise<ISecurityViewData | undefined> {
    const contributionService = pageContext.getService<IVssContributionService>("IVssContributionService");

    // Using ignoreCache = true to make sure we get the latest data from the server on refresh.
    return contributionService
        .getDataAsync<ISecurityViewData>(
            securityViewDataProviderId,
            { permissionSetId: permissionSetId, permissionSetToken: permissionSetToken },
            true
        )
        .then(result => {
            return result;
        });
}

export function createPermissionReport(
    pageContext: IVssPageContext,
    descriptors: string[],
    resourceId: string,
    resourceType: any,
    reportName: string,
    resourceName?: string
): Promise<any> {
    const restClient = getPermissionsReportClient(pageContext);

    const permissionsReportResource: PermissionsReportResource = {
        resourceId: resourceId,
        resourceType: resourceType,
        resourceName: resourceName
    } as PermissionsReportResource;
    const reportRequest: PermissionsReportRequest = {
        descriptors: descriptors,
        reportName: reportName,
        resources: [permissionsReportResource]
    };

    return restClient.createPermissionsReport(reportRequest);
}
